"use client";

import { useTheme } from "@/components/ThemeProvider/ThemeProvider";
import NGAiLogo from "@/assets/icons/NGAiLogo";

function NgAiLogo() {
  const { theme } = useTheme();

  const { logoColor, textColor } =
    theme === "light"
      ? {
          logoColor: "#333333",
          textColor: "#000000",
        }
      : {
          logoColor: "#ffffff",
          textColor: "#ffffff",
        };

  return <NGAiLogo logoColor={logoColor} textColor={textColor} />;
}

export default NgAiLogo;
